import { render, staticRenderFns } from "./ElementPanel.vue?vue&type=template&id=6c88cb98&scoped=true"
import script from "./ElementPanel.vue?vue&type=script&lang=js"
export * from "./ElementPanel.vue?vue&type=script&lang=js"
import style0 from "./ElementPanel.vue?vue&type=style&index=0&id=6c88cb98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c88cb98",
  null
  
)

export default component.exports